import {
  createTableColumn,
  TableCellLayout,
  TableColumnDefinition,
  Theme,
} from "@fluentui/react-components";

import { ReactComponent as ActivateIcon } from "../../../assets/connect-accounted-companies-control-icons/activate.svg";
import { ReactComponent as InactivateIcon } from "../../../assets/connect-accounted-companies-control-icons/inactivate.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/connect-accounted-companies-control-icons/delete.svg";
import { KS_customerservice_Service_Clients_Connect_CompanyAdminDto as ConnectAccountedCompanyDTO } from "../../../CustomerSvcService";
import { Tooltip } from "@fluentui/react-components";

export const tableColsSizes = {
  companyName: {
    minWidth: 120,
    defaultWidth: 250,
  },
  taxNumber: {
    minWidth: 120,
    defaultWidth: 250,
  },
  companyId: {
    minWidth: 120,
    defaultWidth: 250,
  },
  status: {
    minWidth: 120,
    defaultWidth: 500,
  },
};

const styles = `
  .table__control-buttons_container {
    display: flex; flex-direction: row; max-width: 100%;
    justify-content: space-between; align-items: center;
    width: ${tableColsSizes.status.defaultWidth}px;
  }
  button {
    all: unset;
    appearance: none;
    border: none;
    background: none;
    box-shadow: none;
    margin: 0;
    padding: 0;
    font: inherit;
    color: inherit;
    line-height: normal;
    cursor: pointer;
    font-size: 16px;
  }
  .table__control-buttons_row {
    display: flex; 
    flex-direction: row;
    align-items: center;
    gap: 4px;
    padding-top: 4px;
  }
  button:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

const handleRowAction = async (
  action: string | null | undefined,
  accountedCompany?: ConnectAccountedCompanyDTO,
) => {
  switch (action) {
    case "activate":
      // TODO: aktiválási logika ide
      const ok1 = window.confirm(
        `Biztosan aktiválni szeretnéd ${accountedCompany?.name} céget?`,
      );
      if (!ok1) {
        return;
      } else {
        console.log("activate", accountedCompany);
      }
      break;
    case "inactivate":
      // TODO: deaktiválási logika ide
      const ok2 = window.confirm(
        `Biztosan inaktiválni szeretnéd ${accountedCompany?.name} céget?`,
      );
      if (!ok2) {
        return;
      } else {
        console.log("inactivate", accountedCompany);
      }
      break;
    case "delete":
      // delete case is handled below
      const ok3 = window.confirm(
        `Biztosan törölni szeretnéd ${accountedCompany?.name} céget?`,
      );
      if (!ok3) {
        return;
      } else {
        console.log("delete", accountedCompany);
      }
      break;
    default:
      return;
  }
};

export const getColumnsForAccountedCompanies = (
  theme: Theme,
  handleRowAction: (
    actionOrOid: string | null | undefined,
    item?: any,
  ) => void | Promise<void>,
) =>
  [
    createTableColumn<ConnectAccountedCompanyDTO>({
      columnId: "name",
      renderHeaderCell: () => "Cégnév",
      renderCell: (accountedCompany: ConnectAccountedCompanyDTO) => {
        return (
          <TableCellLayout truncate>
            {accountedCompany.name ?? ""}
          </TableCellLayout>
        );
      },
    } as TableColumnDefinition<ConnectAccountedCompanyDTO>),
    createTableColumn<ConnectAccountedCompanyDTO>({
      columnId: "taxNumber",
      renderHeaderCell: () => "Adószám",
      renderCell: (accountedCompany: ConnectAccountedCompanyDTO) => {
        return (
          <TableCellLayout truncate>
            {accountedCompany.taxNumber ?? ""}
          </TableCellLayout>
        );
      },
    } as TableColumnDefinition<ConnectAccountedCompanyDTO>),
    createTableColumn<ConnectAccountedCompanyDTO>({
      columnId: "companyId",
      renderHeaderCell: () => "Company Id",
      renderCell: (accountedCompany: ConnectAccountedCompanyDTO) => {
        return (
          <TableCellLayout truncate>
            {accountedCompany.id ?? ""}
          </TableCellLayout>
        );
      },
    } as TableColumnDefinition<ConnectAccountedCompanyDTO>),

    createTableColumn<ConnectAccountedCompanyDTO>({
      columnId: "status",
      renderHeaderCell: () => "Státusz",
      renderCell: (accountedCompany: ConnectAccountedCompanyDTO) => {
        return (
          <>
            <style>{styles}</style>
            <TableCellLayout
              truncate
              className="table__control-buttons_container"
            >
              <div className="table__control-buttons_container">
                {accountedCompany.isActive ? "Aktív" : "Inaktív"}
                {
                  <div className="table__control-buttons_row">
                    <button
                      onClick={() =>
                        handleRowAction("activate", accountedCompany.id)
                      }
                      disabled={accountedCompany.isActive ?? false}
                    >
                      {accountedCompany.isActive ? (
                        <Tooltip
                          content={"Ez a cég már aktív"}
                          relationship={"description"}
                        >
                          <span className="">
                            <ActivateIcon />
                          </span>
                        </Tooltip>
                      ) : (
                        <ActivateIcon />
                      )}
                    </button>
                    <button
                      onClick={() =>
                        handleRowAction("inactivate", accountedCompany.id)
                      }
                      disabled={!accountedCompany.isActive}
                    >
                      {!accountedCompany.isActive ? (
                        <Tooltip
                          content={"Ez a cég már inaktív"}
                          relationship={"description"}
                        >
                          <span className="">
                            <InactivateIcon />
                          </span>
                        </Tooltip>
                      ) : (
                        <InactivateIcon />
                      )}
                    </button>
                    <button
                      onClick={() =>
                        handleRowAction("delete", accountedCompany.id)
                      }
                      disabled={accountedCompany.isActive ?? false}
                    >
                      {accountedCompany.isActive ? (
                        <Tooltip
                          content={"Aktív céget nem lehet törölni"}
                          relationship={"description"}
                        >
                          <span className="">
                            <DeleteIcon />
                          </span>
                        </Tooltip>
                      ) : (
                        <DeleteIcon />
                      )}
                    </button>
                  </div>
                }
              </div>
            </TableCellLayout>
          </>
        );
      },
    } as TableColumnDefinition<ConnectAccountedCompanyDTO>),
  ] as TableColumnDefinition<ConnectAccountedCompanyDTO>[];
